import { LessonPin } from '@lessonup/teaching-core';
import { PinView } from '@lessonup/typescript-core/ui';
import { IframeMessaging } from '@lessonup/typescript-core/utils';
import { Button } from '@lessonup/ui-components';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle -- auto-generated TECH-258
import { PIN_SEARCH_TRANSLATION_NS } from '../PinSearchPage';

interface VideoResultProps {
  pin: LessonPin;
}

const handleVideoResolve = (url: string | undefined) => {
  if (!url) return;
  IframeMessaging.send('video-url', url);
};

export const VideoResult: React.FunctionComponent<VideoResultProps> = ({ pin }) => {
  const { t } = useTranslation(PIN_SEARCH_TRANSLATION_NS);

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- auto-generated TECH-258
    <div className={classNames('pin-result')} key={pin._id} onClick={() => handleVideoResolve(pin.item.url)}>
      <div className={`pin-size-${400}`}>
        <PinView pin={pin} isThumb={true} />
      </div>
      <div className="actions">
        <Button buttonType="primary">{t('useInLesson')}</Button>
      </div>
    </div>
  );
};
